import React from "react";
import AlmeOverlaySurveyDialog from "../../AlmeOverlayForm/OverlaySurvey/AlmeOverlaySurveyDialog";
import { getQualtricsSurveyUrl } from "../../../utils/QualtricsSurveyUtils";
import { getQualtricsCookieValue } from "../../../utils/QualtricsCookiesUtils";
import { QualtricsCookies } from "../../Common/constants";
export function isLiveChatSurveyResponse(response) {
    const hasChatEnded = response.extensionData.MessageOrigin === "Session-End";
    const sessionTimedout = !!response.extensionData.isSessionTimeout;
    return (hasChatEnded && !sessionTimedout);
}
const AlmeLiveChartSurveyResponse = (props) => {
    const surveyURL = getQualtricsSurveyUrl(props.appConfig, true, props.isLoggedIn, props.response.extensionData.chatId);
    if (!isLiveChatSurveyResponse(props.response) || props.response.fromHistory || (surveyURL === undefined) || (surveyURL === '')) {
        return null;
    }
    const handleLiveChatSurveyClose = () => {
        props.markUsedResponse(props.response);
        props.setIsDialogOpen(false);
    };
    return (React.createElement(React.Fragment, null, getQualtricsCookieValue(QualtricsCookies.HadLiveChat) && surveyURL ?
        React.createElement(AlmeOverlaySurveyDialog, { isOpen: true, surveyURL: surveyURL, onCloseSurvey: handleLiveChatSurveyClose }) : null));
};
export default AlmeLiveChartSurveyResponse;
